import Numeral from 'numeral';
import Vue from 'vue';

Vue.filter('formatNumber', value => Numeral(value).format());

Vue.filter('shortNumber', (number) => {
	
	if (!number) {
		return '(no data)';
	}
	
	const formats = {
		'T': 1e12, // trillion
		'B': 1e9, // billion
		'M': 1e6, // million
		'K': 1e3, // thousand
	}
	
	if (number < formats['K']) {
		return Numeral(number).format('0');
	}
	
	for (const suffix in formats) {
		if (number < formats[suffix])
			continue;
		
		const newNumber = number / formats[suffix];
		const format = newNumber >= 100 ? '0' : '0,0.0';
		const formattedNumber = Numeral(newNumber).format(format);

		return `${formattedNumber} ${suffix}`;
	}
});

// Vue.filter('capitalize', value => value.charAt(0).toUpperCase() + value.slice(1));

/** @todo Momentjs date filter if needed */
// Vue.filter('date', (value, format) => {
// 	console.log(value);
// 	console.log(format);
// });
